const primary = '#023373'

const colors = {
  primary,
  sidebarBgColor: '#E4E9F0',
  sidebarMenuItemBgColorActive: '#CCD5E2',
  sidebarMenuItemTextColor: '#aaaaaa',
  sidebarMenuItemTextColorActive: primary,
  navbarAvatarNameColor: '#6a707e',
  // certificates
  cert1stInfoCardBgColor: primary,
  cert2ndInfoCardBgColor: '#045ead',
  cert3rdInfoCardBgColor: '#BF2C47',
  certInfoCardColor: '#ffffff'
  // button
}

export { colors }




// WEBPACK FOOTER //
// ./src/styles/variables.js